import { PayPalEventDeliveryOrderByEnum } from "@admin_api/models/pay-pal-event-delivery-order-by-enum";
import { Component, Input } from "@angular/core";

@Component({
    selector: "app-paypal-events-table-cell-content",
    templateUrl: "./paypal-events-table-cell-content.component.html",
    styleUrls: ["./paypal-events-table-cell-content.component.less"],
    standalone: false
})
export class PayPalEventsTableCellContentComponent {

    @Input() columnId: string;
    @Input() element: any;

    PayPalEventDeliveryOrderByEnum = PayPalEventDeliveryOrderByEnum;

}
